import { USER_ROLE } from 'src/lib/user'
import { doNotSell } from 'lib/utils'

export const trackAmplitude = (eventName, eventData, viewer = null) => {
  if (doNotSell()) return
  const amplitudeInstance = typeof amplitude !== 'undefined' && amplitude.getInstance()
  if (!amplitudeInstance) return

  const signedInAsAdmin = document.cookie.split('; ').includes('signed_in_through_admin=true')

  if (!signedInAsAdmin && (!viewer || viewer.role === USER_ROLE)) {
    if (viewer) amplitudeInstance.setUserId(viewer.id)
    amplitudeInstance.logEvent(eventName, eventData)
  } else {
    /* eslint-disable-next-line no-console */
    console.log(`Amplitude is disabled for admins: "${eventName}", ${JSON.stringify(eventData)}`)
  }
}

// More info on GoogleAds conversion tracking here:
// https://support.google.com/google-ads/answer/6095821?co=ADWORDS.IsAWNCustomer=true&oco=0#get_tag
export const GoogleAds = {
  loadedGAdsIds: [],
  isScriptLoaded: false,

  initialize(GoogleAdsId) {
    if (!GoogleAdsId) {
      return
    }

    if (!this.isScriptLoaded) {
      const script = document.createElement('script')
      script.src = 'https://www.googletagmanager.com/gtag/js'
      script.async = true
      document.head.appendChild(script)

      window.dataLayer = window.dataLayer || []

      this.isScriptLoaded = true
    }

    if (this.loadedGAdsIds.includes(GoogleAdsId)) {
      return
    }
    this.gtag('js', new Date())
    this.gtag('config', GoogleAdsId)
    this.loadedGAdsIds.push(GoogleAdsId)
  },

  gtag() {
    // eslint-disable-next-line no-undef, prefer-rest-params
    dataLayer.push(arguments)
  },

  send(sendTo) {
    if (!sendTo) {
      return
    }

    const GoogleAdsId = sendTo.split('/')[0]
    this.initialize(GoogleAdsId)

    this.gtag('event', 'conversion', { send_to: sendTo })
  },
}

export const trackGetTickets = (trackingParams) => {
  const { timedEntry, eventId, hostId, widget, viewer } = trackingParams
  const { referrer } = document
  const url = referrer ? new URL(referrer) : {}
  const eventType = timedEntry ? 'timed' : 'non_timed'

  trackAmplitude('Get Tickets', {
    origin: url.origin,
    listing_id: eventId,
    host_id: hostId,
    event_type: eventType,
    referrer,
    widget,
  }, viewer)
}
